module.exports = __webpack_public_path__ + "img/052b8e7.png";